const translations: Record<string, string> = {
  // Navbar
  'nav.home': '首頁',
  'nav.services': '服務',
  'nav.custom': '客製網站',
  'nav.modules': '模組',
  'nav.brand': '品牌',
  'nav.contact': '聯絡',
  'nav.cta': '免費諮詢',

  // Hero
  'hero.badge': '專業數位設計服務',
  'hero.prefix': '專為您打造',
  'hero.h0': '客製網站',
  'hero.h1': '品牌識別',
  'hero.h2': '模組化建站',
  'hero.sub': '我們將策略思維與精緻美學相融合，打造令人難忘的數位體驗。',
  'hero.cta1': '探索服務',
  'hero.cta2': '免費諮詢',
  'hero.stat0.sfx': '+',
  'hero.stat0.lbl': '成功專案',
  'hero.stat1.sfx': '%',
  'hero.stat1.lbl': '客戶滿意度',
  'hero.stat2.sfx': '+',
  'hero.stat2.lbl': '年經驗',
  'hero.stat3.sfx': '+',
  'hero.stat3.lbl': '品牌客戶',
  'hero.scroll': '向下捲動',

  // Services Section
  'svc.eyebrow': '我們的服務',
  'svc.title': '四大核心服務',
  'svc.sub': '從網站設計、模組系統到品牌建立——完整的數位品牌解決方案',
  'svc.c0.label': '客製網站',
  'svc.c0.title': '客製化網站開發',
  'svc.c0.desc': '從視覺策略到前端開發，我們打造完美呈現您品牌的客製響應式網站。',
  'svc.c0.cta': '瞭解詳情',
  'svc.c0.f0': '全客製視覺設計',
  'svc.c0.f1': '響應式跨裝置適配',
  'svc.c0.f2': 'SEO 技術優化',
  'svc.c0.f3': '高效能載入速度',
  'svc.c0.f4': '自動化安全測試',
  'svc.c1.label': '模組庫',
  'svc.c1.title': '可擴展 UI 設計系統',
  'svc.c1.desc': '提供 130+ 精心打造的 UI 元件，即插即用，確保一致性並將開發效率提升 3 倍。',
  'svc.c1.cta': '瀏覽模組',
  'svc.c1.f0': '100+ 優質元件',
  'svc.c1.f1': '一致性設計系統',
  'svc.c1.f2': '拖曳式組裝',
  'svc.c1.f3': '持續更新迭代',
  'svc.c2.label': '品牌識別',
  'svc.c2.title': '品牌識別設計',
  'svc.c2.desc': '建構完整視覺體系，從 Logo 設計到品牌規範，讓您的品牌脫穎而出。',
  'svc.c2.cta': '瞭解更多',
  'svc.c2.f0': '創意 Logo 設計',
  'svc.c2.f1': '色彩與字體系統',
  'svc.c2.f2': '品牌應用設計',
  'svc.c2.f3': '完整 VI 規範',
  'svc.c3.label': 'SEO & 行銷',
  'svc.c3.title': 'SEO & 數位行銷',
  'svc.c3.desc': '結合內容策略與技術 SEO，提升排名、吸引精準流量並提高轉換率。',
  'svc.c3.cta': '瞭解更多',
  'svc.c3.f0': '關鍵字策略',
  'svc.c3.f1': 'Core Web Vitals',
  'svc.c3.f2': '內容行銷',
  'svc.c3.f3': '數據分析與報告',
  'svc.qa.eyebrow': '我們的品質承諾',
  'svc.qa.title': '確保所有數位解決方案的穩定性、安全性與高效能。',
  'svc.qa.sub': '自動化精準檢測結合人工專業審核，我們嚴格驗證每一個細節，確保最高穩定性與零風險部署。',
  'svc.qa0.title': '1,200+ 測試案例',
  'svc.qa0.text': '自動化腳本涵蓋每個功能模組，確保每次更新都堅如磐石',
  'svc.qa1.title': '零風險上線',
  'svc.qa1.text': '完整 OWASP 漏洞掃描，確保網站上線前完全安全',
  'svc.qa2.title': '效能壓力測試',
  'svc.qa2.text': '模擬峰值流量，確保網站在任何負載下都快速穩定',
  'svc.qa3.title': '8 名專職 QA 工程師',
  'svc.qa3.text': '資深 QA 工程師把關每次交付——品質絕不妥協',

  // Custom Website Section
  'cw.eyebrow': '客製網站',
  'cw.titleL1': '專屬數位體驗',
  'cw.titleL2': '',
  'cw.sub': '您的品牌值得擁有更多，而不只是套版。從第一行程式碼到最後一個像素，我們精心打造完美呈現您獨特身份的客製網站。',
  'cw.badge.label': '平均交付週期',
  'cw.badge.value': '8 週上線',
  'cw.f0.title': '全客製視覺設計',
  'cw.f0.desc': '完美匹配您品牌的調性與願景，無套版、零妥協',
  'cw.f1.title': '響應式跨裝置適配',
  'cw.f1.desc': '在手機、平板與桌機上均完美呈現',
  'cw.f2.title': 'SEO 技術優化',
  'cw.f2.desc': '符合 Core Web Vitals，助力提升排名與自然流量',
  'cw.f3.title': '高效能載入速度',
  'cw.f3.desc': '優化程式碼與媒體資源，實現極速頁面載入',
  'cw.f4.title': '自訂 CMS 整合',
  'cw.f4.desc': '直觀的後台系統，輕鬆隨時更新內容',
  'cw.f5.title': '安全與維護',
  'cw.f5.desc': '企業級 SSL、定期備份與持續技術支援',
  'cw.f6.title': '專業自動化測試',
  'cw.f6.desc': '嚴格的上線前驗證，確保絕對穩定性與零風險部署。',
  'cw.f6.badge': '核心優勢',
  'cw.qa.eyebrow': '品質保證',
  'cw.qa.badge': '品質保證',
  'cw.qa.titleL1': '每個網站都經過',
  'cw.qa.titleL2': '專業自動化測試',
  'cw.qa.desc': '我們專職的 QA 工程師團隊採用全自動化測試流程進行多層驗證——功能測試、安全掃描和效能負載測試——確保您的網站以最穩定、最安全的狀態上線。',
  'cw.qs0.label': '自動化測試案例',
  'cw.qs1.label': '上線前安全掃描',
  'cw.qs2.label': '上線時已知漏洞',
  'cw.qs3.label': '專職 QA 工程師',
  'cw.tl.title': '結構化交付流程',
  'cw.tl.sub': '透明的 8 週旅程，您在每個里程碑都掌握全局、全程參與。',
  'cw.tl0.week': '第 1-2 週',
  'cw.tl0.phase': '探索發現',
  'cw.tl0.desc': '透過深度市場調研與策略定位，挖掘您品牌的核心價值',
  'cw.tl1.week': '第 3-4 週',
  'cw.tl1.phase': '視覺設計',
  'cw.tl1.desc': '將策略轉化為美學，不斷迭代設計方案直至與您的願景完美契合',
  'cw.tl2.week': '第 5-7 週',
  'cw.tl2.phase': '開發實作',
  'cw.tl2.desc': '用精良程式碼將設計化為現實，無縫整合 CMS，精細調優效能',
  'cw.tl3.week': '第 8 週',
  'cw.tl3.phase': '上線發布',
  'cw.tl3.desc': '執行完美的零風險部署，並提供全面培訓與持續支援',

  // Module Library
  'mod.eyebrow': '模組庫',
  'mod.title': '專業模組庫',
  'mod.sub': '6 大分類、130+ 優質 UI 元件，專為快速組裝設計，同時保持完美的視覺一致性。',
  'mod.hint': '滑鼠懸停查看模組詳情',
  'mod.c0.name': '版面配置元件',
  'mod.c0.desc': 'Hero Banner、內容網格與靈活分隔線——構建強健頁面結構的基礎模組。',
  'mod.c0.unit': '個模組',
  'mod.c0.i0': 'Hero Banner × 8',
  'mod.c0.i1': '頁面版型 × 6',
  'mod.c0.i2': '內容網格 × 5',
  'mod.c0.i3': '分割畫面 × 5',
  'mod.c1.name': '導覽元件',
  'mod.c1.desc': '直觀的頂部導覽、側邊欄與超級選單，引導使用者流暢瀏覽您的數位體驗。',
  'mod.c1.unit': '個模組',
  'mod.c1.i0': '頂部導覽 × 6',
  'mod.c1.i1': '漢堡選單 × 4',
  'mod.c1.i2': '側邊欄導覽 × 4',
  'mod.c1.i3': '麵包屑導覽 × 4',
  'mod.c2.name': '電子商務',
  'mod.c2.desc': '轉換率優化的商品卡片、動態購物車與流暢結帳流程，最大化銷售額。',
  'mod.c2.unit': '個模組',
  'mod.c2.i0': '商品卡片 × 10',
  'mod.c2.i1': '購物車 × 5',
  'mod.c2.i2': '結帳步驟 × 6',
  'mod.c2.i3': '商品詳情 × 9',
  'mod.c3.name': '表單控制項',
  'mod.c3.desc': '互動式輸入框、智慧下拉選單與多步驟表單，高效收集資料。',
  'mod.c3.unit': '個模組',
  'mod.c3.i0': '文字輸入框 × 6',
  'mod.c3.i1': '下拉選單 × 5',
  'mod.c3.i2': '檔案上傳 × 4',
  'mod.c3.i3': '多步驟表單 × 7',
  'mod.c4.name': '媒體展示',
  'mod.c4.desc': '沉浸式圖片相簿、動態輪播與自訂影片播放器，讓您的視覺資產煥發生機。',
  'mod.c4.unit': '個模組',
  'mod.c4.i0': '圖片相簿 × 7',
  'mod.c4.i1': '影片播放器 × 4',
  'mod.c4.i2': '輪播圖 × 5',
  'mod.c4.i3': '燈箱效果 × 4',
  'mod.c5.name': '資料視覺化',
  'mod.c5.desc': '精美圖表、互動式儀表板與即時 KPI 卡片，呈現清晰的業務洞察。',
  'mod.c5.unit': '個模組',
  'mod.c5.i0': '圖表 × 6',
  'mod.c5.i1': '進度條 × 4',
  'mod.c5.i2': '儀表板 × 3',
  'mod.c5.i3': 'KPI 卡片 × 3',
  'mod.apply': '申請此模組',
  'mod.cta.title': '需要客製解決方案？',
  'mod.cta.sub': '告訴我們您的具體需求，我們的團隊將為您量身打造專屬模組',
  'mod.cta.btn': '申請客製模組',

  // Brand Identity
  'br.eyebrow': '品牌識別',
  'br.title': '打造標誌性品牌',
  'br.sub': '品牌不只是視覺——它是您核心身份的策略表達。我們構建有機統一的視覺體系，留下深刻而持久的印象。',
  'br.c0.title': '創意 Logo 設計',
  'br.c0.desc': '我們將品牌核心價值凝練為強力且易識別的標誌，精心設計以在所有媒介上完美呈現。',
  'br.c0.f0': '多方案概念提案',
  'br.c0.f1': '向量格式交付',
  'br.c0.f2': '黑白與彩色版本',
  'br.c0.f3': '結構化修改輪次',
  'br.c1.title': '視覺識別系統',
  'br.c1.desc': '系統化定義色彩體系、字體排版與視覺資產，確保每個觸點的完美一致性。',
  'br.c1.f0': '品牌色彩規範',
  'br.c1.f1': '字體排版系統',
  'br.c1.f2': '客製圖形元素',
  'br.c1.f3': '完整 VI 規範手冊',
  'br.c2.title': '品牌應用設計',
  'br.c2.desc': '將品牌識別轉化為有形資產，從數位模板到高端印刷品，讓您的品牌在每個場合都光彩奪目。',
  'br.c2.f0': '高端文具設計',
  'br.c2.f1': '簡報模板',
  'br.c2.f2': '社群媒體素材',
  'br.c2.f3': '行銷推廣物料',
  'br.proc.eyebrow': '我們的流程',
  'br.proc.title': '四步品牌設計流程',
  'br.proc.sub': '以策略為先的嚴謹方法，將您的核心願景轉化為標誌性視覺識別。',
  'br.proc0.title': '品牌調研',
  'br.proc0.desc': '挖掘品牌 DNA，透過深度分析市場、受眾與競爭對手，構建堅實的策略基礎',
  'br.proc1.title': '概念開發',
  'br.proc1.desc': '將洞察轉化為美學，透過精選情境板與概念草圖探索多個差異化設計方向',
  'br.proc2.title': '設計深化',
  'br.proc2.desc': '透過結構化修改輪次精心打磨選定方案，直至完美體現品牌靈魂',
  'br.proc3.title': '品牌交付',
  'br.proc3.desc': '為您的未來做足準備，交付完整的資產庫與精準規範，確保品牌執行無懈可擊',
  'br.proc.cta': '開始品牌專案',

  // Contact
  'ct.eyebrow': '聯絡我們',
  'ct.title': '啟動您的專案',
  'ct.sub': '與我們的團隊分享您的願景，我們將在一個工作天內審核您的需求並與您聯繫。',
  'ct.info0.label': '地址',
  'ct.info0.value': 'No.7 Xinyi Rd Sec.5, Xinyi Dist., Taipei',
  'ct.info1.label': '電子郵件',
  'ct.info1.value': 'info@forwardthai.com',
  'ct.info2.label': '電話',
  'ct.info2.value': '+886 2 2345 6789',
  'ct.info3.label': '營業時間',
  'ct.info3.value': '週一至週五 09:00–18:00',
  'ct.social.title': '追蹤我們',
  'ct.form.nameLabel': '姓名 *',
  'ct.form.emailLabel': '電子郵件 *',
  'ct.form.serviceLabel': '服務類型',
  'ct.form.budgetLabel': '預算範圍',
  'ct.form.messageLabel': '專案描述',
  'ct.form.namePlaceholder': '您的姓名',
  'ct.form.emailPlaceholder': 'your@email.com',
  'ct.form.msgPlaceholder': '請描述您的專案需求、目標及特殊要求...',
  'ct.form.svcDefault': '請選擇服務',
  'ct.form.svc0': '客製網站設計',
  'ct.form.svc1': '品牌識別設計',
  'ct.form.svc2': '模組庫',
  'ct.form.svc3': 'SEO 優化',
  'ct.form.svc4': '其他',
  'ct.form.bgtDefault': '請選擇預算範圍',
  'ct.form.bgt0': '$1,500 以下',
  'ct.form.bgt1': '$1,500 – $5,000',
  'ct.form.bgt2': '$5,000 – $10,000',
  'ct.form.bgt3': '$10,000 以上',
  'ct.form.submit': '提交諮詢',
  'ct.form.submitting': '提交中...',
  'ct.form.successTitle': '諮詢已收到',
  'ct.form.successDesc': '感謝您的聯繫，我們的團隊將在一個工作天內審核您的專案詳情並與您取得聯繫。',
  'ct.form.refill': '返回首頁',
  'ct.form.error': '提交失敗，請稍後再試。',

  // Footer
  'ft.desc': '您的數位創意合作夥伴，專注企業品牌設計，用精緻設計打造獨特的數位身份。',
  'ft.group0.title': '服務',
  'ft.group0.l0': '客製網站設計',
  'ft.group0.l1': '品牌識別',
  'ft.group0.l2': '模組庫',
  'ft.group0.l3': 'SEO 行銷',
  'ft.group0.l4': '網站維護',
  'ft.group1.title': '資源',
  'ft.group1.l0': '設計部落格',
  'ft.group1.l1': '模組預覽',
  'ft.group1.l2': '設計指南',
  'ft.group1.l3': '案例研究',
  'ft.group1.l4': '常見問題',
  'ft.group2.title': '關於我們',
  'ft.group2.l0': '我們的故事',
  'ft.group2.l1': '設計理念',
  'ft.group2.l2': '團隊',
  'ft.group2.l3': '加入我們',
  'ft.group2.l4': '聯絡',
  'ft.legal0': '隱私權政策',
  'ft.legal1': '服務條款',
  'ft.legal2': 'Cookie 設定',
  'ft.tagline': '專業數位設計服務',
  'ft.backtop': '返回頂部',
};
export default translations;
